import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faPlus } from '@fortawesome/free-solid-svg-icons';
import PartNotFoundForm from './componentes/PartNotFoundForm';
import PartNotFoundHistory from './componentes/PartNotFoundHistory';

const PartNotFoundModal = () => {
    const [isAddView, setIsAddView] = useState(true);

    const handleChangeView = () => {
        setIsAddView((prev) => !prev);
    };

    return (
        <div className='d-flex flex-column gap-2'>
            <div className='d-flex justify-content-end w-100'>
                <button className="btn btn-add" onClick={handleChangeView}>
                    <span className="add position-relative">
                        <FontAwesomeIcon
                            icon={isAddView ? faList : faPlus}
                            size="1x"
                            className="action"
                            color="#215732"
                        />
                    </span>
                    {isAddView ? 'Ver histórico' : 'Añadir pieza'}
                </button>
            </div>

            {isAddView ? <PartNotFoundForm /> : <PartNotFoundHistory />}
        </div>
    );
};

export default PartNotFoundModal;
